export default __webpack_public_path__ + "img/f374e5f6ab004b4cfdb1ee96c20eb04c.svg";